import { LastMessagesMap } from '@/utils/pubnub/pubnub.types';

export function checkOnUnreadMessage(lastMessagesMap: LastMessagesMap | null) {
  if (!lastMessagesMap) return false;

  return Object.keys(lastMessagesMap || {}).some(
    chatId => !lastMessagesMap[chatId].isReadMessage
  );
}
